import {useEffect, useRef, useState} from "react";
import {isCompanyEik, eikSearchUrl, TRADE_REGISTER_URL} from "../../utils/bullstat";

export const CompanyInfoModal = ({info}) => {
    // Ч2: справка за фирмата навън — адрес на регистрация, управител.
    // Предлага се САМО когато номерът е ЕИК; при ЕГН на физическо лице не се
    // предлага нищо (виж utils/bullstat.js защо).
    const търсене = eikSearchUrl(info.bullstat);
    const [копирано, setКопирано] = useState(false);
    const таймер = useRef(null);

    // Друг ползвател → надписът „копирано" от предишния не бива да остава.
    useEffect(() => {
        setКопирано(false);
        return () => clearTimeout(таймер.current);
    }, [info.bullstat]);

    // `тихо` — при неуспех да не изскача нищо. Ползва се от връзката към
    // регистъра: тя и без това отваря нов подпрозорец, а изскачаща кутия отгоре
    // би дошла точно докато погледът е отишъл другаде. Копчето „копирай" няма
    // друг изход, затова там неуспехът пита.
    const копирай = ({тихо} = {}) => {
        const номер = String(info.bullstat ?? '');
        return navigator.clipboard.writeText(номер)
            .then(() => {
                setКопирано(true);
                clearTimeout(таймер.current);
                таймер.current = setTimeout(() => setКопирано(false), 5000);
            })
            .catch(() => {
                if (!тихо) window.prompt('Копирайте номера:', номер);
            });
    };

    return (
        <div className="modal fade" id="companyInfoModal" tabIndex="-1" aria-labelledby="exampleModalLabel"
             aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">Информация</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                    </div>
                    <div className="modal-body">

                        <dl className="row">
                            <dt className="col-sm-3">Фирма</dt>
                            <dd className="col-sm-9">{info.company_name}</dd>
                            <dt className="col-sm-3">Лице</dt>
                            <dd className="col-sm-9">{info.accountable_person}</dd>
                            <dt className="col-sm-3">Булстат</dt>
                            <dd className="col-sm-9">
                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                    {търсене
                                        ? <a href={търсене} target="_blank" rel="noopener noreferrer"
                                             title="Търсене по ЕИК — адрес на регистрация, управител">
                                            {info.bullstat}
                                          </a>
                                        : <span>{info.bullstat}</span>}
                                    <button type="button" className="btn btn-outline-secondary btn-sm py-0"
                                            onClick={() => копирай()} title="Копирай номера">копирай</button>
                                    {копирано && (
                                        <span style={{fontSize: "13px", color: "var(--app-success-fg)"}}>
                                            номерът е копиран
                                        </span>
                                    )}
                                </div>
                                {търсене && (
                                    <div className="mt-1" style={{fontSize: "13px"}}>
                                        {/* Ч2 (поправено 01.09.2026): води към самата форма
                                            „Справка по физическо или юридическо лице", а не към
                                            входа на портала. Адрес с ЕИК в него няма, затова
                                            щракването взима номера в паметта — остава само да
                                            се постави в полето. */}
                                        <a href={TRADE_REGISTER_URL} target="_blank" rel="noopener noreferrer"
                                           onClick={() => копирай({тихо: true})}>
                                            Справка в Търговския регистър
                                        </a>
                                        <span style={{color: "var(--app-muted)"}}>
                                            {" "}— номерът се копира; поставете го в полето
                                            ЕИК/ПИК/БУЛСТАТ.
                                        </span>
                                    </div>
                                )}
                                {!isCompanyEik(info.bullstat) && (
                                    <div className="mt-1" style={{fontSize: "13px", color: "var(--app-muted)"}}>
                                        Външна справка не се предлага — това не е ЕИК на фирма, а номер на
                                        физическо лице.
                                    </div>
                                )}
                            </dd>
                            <dt className="col-sm-3">Адрес</dt>
                            <dd className="col-sm-9">{`${info.address}, ${info.city}`}</dd>
                            <dt className="col-sm-3">Телефон</dt>
                            <dd className="col-sm-9">{info.phone}</dd>
                            <dt className="col-sm-3">Забележка</dt>
                            <dd className="col-sm-9">{info.company_note}</dd>

                        </dl>

                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Затвори</button>
                    </div>
                </div>
            </div>
        </div>
    )
};
